<app-alert></app-alert>
<app-global-spinner></app-global-spinner>
<router-outlet></router-outlet>
<!-- <ng-container *ngIf="isVisibleLogout">
    <app-countdown-stopwatch></app-countdown-stopwatch>
</ng-container> -->
